import { AnalyticsEventType } from "@/constants/analytics";
import * as amplitude from "@/utils/amplitude";

export const trackEvent = (eventName: AnalyticsEventType, options?: Record<string, unknown>) => {
  amplitude.trackAmplitudeEvent(eventName, options);
};
